
// Helper function to map Supabase errors to user-friendly messages
export const getErrorMessage = (error: any): string => {
  // Common auth error messages
  const errorMap: Record<string, string> = {
    'Email not confirmed': 'Please check your email and confirm your account before logging in.',
    'Invalid login credentials': 'The email or password you entered is incorrect.',
    'Email already registered': 'This email is already registered. Try logging in instead.',
    'Invalid email': 'Please enter a valid email address.',
    'Password should be at least 6 characters': 'Password must be at least 6 characters long.',
    'Rate limit exceeded': 'Too many attempts. Please try again later.',
    'Invalid captcha token': 'Security verification failed. Please refresh and try again.',
    'New password should be different from the old password': 'You cannot reuse your current password.',
    'Invalid or expired JWT': 'Your password reset link is invalid or has expired.',
    'No session found': 'Auth required. Try again.',
    'JWT expired': 'Your password reset link is invalid or has expired.',
    'Service unavailable': 'Cannot reach auth service. Check your connection.',
  };

  // Special case handling for database error codes
  if (error.code === '23505') {
    return 'An account with this email already exists.';
  }

  // Check if the error message is in our map
  for (const [key, value] of Object.entries(errorMap)) {
    if (error.message && error.message.includes(key)) {
      return value;
    }
  }

  // Default generic error message
  return error.message || 'An unexpected error occurred. Please try again.';
};
